<template>
  <div class="common-code-container">
    <commonInputDate
      ref="dateWithZone"
      format="yyyy-MM-dd HH:mm"
      @focus="focus"
      @blur="blur"
      :popperClass="parentsClass"
      label="dasda"
      :picker-options="pickerOptions"
      @datePicker="datePicker"
      type="datetime"
      v-model="date"
      :inputWidth="180"></commonInputDate>
  </div>
</template>
<script>
import { timeZoneList } from '@/config/time-zone'
let index = 1
export default {
  name: 'CommonDateWithZone',
  data() {
    return {
      zoneValue: '',
      parentsClass: '',
      date: '',
      zoneNodeMap: {},
      zoneNodeClass: 'data-map-select-button',
      pickerOptions: {
        shortcuts: []
      },
    }
  },
  watch: {
    value: {
      handler(val) {
        this.date = val
      },
      immediate: true
    },
    date() {
      if (this.date) {
        this.$emit('changeDate',{
          date: this.date,
          zone: this.zoneValue
        })
      }
    },
    zoneValue() {
      if (this.date) {
        this.$emit('changeDate', {
          date: this.date,
          zone: this.zoneValue
        })
      }
    }
  },
  props: {
    zone: {
      type: String,
      default: ''
    },
    value: {
      type: [Number, String, Date, Object],
      default: ''
    }
  },
  created() {
    index = index + 1
    this.parentsClass = 'index' + index
    this.pickerOptions.shortcuts = timeZoneList.map(item => {
      return {
        text: item.value,
        onClick: () => {
          this.chooseZone(item.value)
        }
      }
    })
  },
  methods: {
    blur() {
      this.$emit('blur')
    },
    focus() {
      this.$emit('focus')
      this.zoneValue = this.zone || this.pickerOptions.shortcuts[0].text
      this.$nextTick(() => {
        let parentsNode = document.getElementsByClassName(this.parentsClass)
        const childrenNode = document.getElementsByClassName('el-picker-panel__shortcut')
        this.zoneNodeMap = {}
        childrenNode.forEach(item => {
          if (parentsNode[0].contains(item)){
            const label = item.innerText
            label && (this.zoneNodeMap[label] = item)
          }
        });
        this.chooseZone(this.zoneValue)
        parentsNode = null
      })
    },
    chooseZone(zone) {
      if (this.zoneNodeMap) {
        Object.keys(this.zoneNodeMap).forEach(item => {
          this.zoneNodeMap[item] && (this.zoneNodeMap[item].classList.remove(this.zoneNodeClass))
        })
        this.zoneNodeMap[zone] && this.zoneNodeMap[zone].classList.add(this.zoneNodeClass)
      }
      this.zoneValue = zone
    },
    datePicker(...res) {
      console.log(res)
    }
  },
}
</script>
<style lang="scss" scoped>

</style>
<style lang="scss">
.data-map-select-button{
  color: #4066d4 !important;
  &:hover{
    color: #4066d4 !important;
  }
}
</style>
